/**
 * Holds basic table information including offset length and checksum.
 *
 * @private
 */
var _TrueTypeTableInfo = /** @class */ (function () {
    function _TrueTypeTableInfo() {
    }
    Object.defineProperty(_TrueTypeTableInfo.prototype, "_empty", {
        /**
         * Indicates whether the table entry has zero offset length and checksum.
         *
         * @private
         * @returns {boolean} returns whether true or false.
         */
        get: function () {
            var empty = (this._offset === this._length && this._length === this._checksum && this._checksum === 0);
            return empty;
        },
        enumerable: true,
        configurable: true
    });
    return _TrueTypeTableInfo;
}());
export { _TrueTypeTableInfo };
/**
 * Represents the OS two table containing weight width metrics and unicode ranges.
 *
 * @private
 */
var _TrueTypeOS2Table = /** @class */ (function () {
    function _TrueTypeOS2Table() {
    }
    return _TrueTypeOS2Table;
}());
export { _TrueTypeOS2Table };
/**
 * Represents the post table containing italic angle fixed pitch and type metrics.
 *
 * @private
 */
var _TrueTypePostTable = /** @class */ (function () {
    function _TrueTypePostTable() {
    }
    return _TrueTypePostTable;
}());
export { _TrueTypePostTable };
/**
 * Contains name table records including format count and string offsets.
 *
 * @private
 */
var _TrueTypeNameTable = /** @class */ (function () {
    function _TrueTypeNameTable() {
    }
    return _TrueTypeNameTable;
}());
export { _TrueTypeNameTable };
/**
 * Stores microsoft cmap subtable fields including segment arrays and glyph mappings.
 *
 * @private
 */
var _TrueTypeMicrosoftCmapSubTable = /** @class */ (function () {
    function _TrueTypeMicrosoftCmapSubTable() {
    }
    return _TrueTypeMicrosoftCmapSubTable;
}());
export { _TrueTypeMicrosoftCmapSubTable };
/**
 * Represents the horizontal header table including ascender descender and metric counts.
 *
 * @private
 */
var _TrueTypeHorizontalHeaderTable = /** @class */ (function () {
    function _TrueTypeHorizontalHeaderTable() {
    }
    return _TrueTypeHorizontalHeaderTable;
}());
export { _TrueTypeHorizontalHeaderTable };
/**
 * Represents the head table containing global font properties and bounding box data.
 *
 * @private
 */
var _TrueTypeHeadTable = /** @class */ (function () {
    function _TrueTypeHeadTable() {
    }
    return _TrueTypeHeadTable;
}());
export { _TrueTypeHeadTable };
/**
 * Defines the cmap table header including version and subtable count.
 *
 * @private
 */
var _TrueTypeCmapTable = /** @class */ (function () {
    function _TrueTypeCmapTable() {
    }
    return _TrueTypeCmapTable;
}());
export { _TrueTypeCmapTable };
/**
 * Holds platform and encoding identifiers and the offset to a cmap subtable.
 *
 * @private
 */
var _TrueTypeCmapSubTable = /** @class */ (function () {
    function _TrueTypeCmapSubTable() {
    }
    return _TrueTypeCmapSubTable;
}());
export { _TrueTypeCmapSubTable };
/**
 * Represents an apple cmap subtable with format length and version.
 *
 * @private
 */
var _TrueTypeAppleCmapSubTable = /** @class */ (function () {
    function _TrueTypeAppleCmapSubTable() {
    }
    return _TrueTypeAppleCmapSubTable;
}());
export { _TrueTypeAppleCmapSubTable };
/**
 * Represents a trimmed cmap subtable with base code and entry count.
 *
 * @private
 */
var _TrueTypeTrimmedCmapSubTable = /** @class */ (function () {
    function _TrueTypeTrimmedCmapSubTable() {
    }
    return _TrueTypeTrimmedCmapSubTable;
}());
export { _TrueTypeTrimmedCmapSubTable };
